import { FooterContainer } from "./styles"

const Footer = () => {
  return (
    <FooterContainer />
  );
};

export default Footer;